import {Component, OnInit, ViewChild} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Globals} from "../../services/globals";
import {CustomValidators} from '../custom-validator/custom-validator.component';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {AuthenticationService} from "../../services/authentication.service";
import {Location, LocationStrategy, PathLocationStrategy} from "@angular/common";
import {TosterMessageService} from "../../services/toster-message.service";

@Component({
    selector: 'app-app-reset-password',
    templateUrl: './app-reset-password.component.html',
    styleUrls: ['./app-reset-password.component.scss'],
    providers: [AuthenticationService,TosterMessageService]
})
export class AppResetPasswordComponent implements OnInit {
    public frmSignup: FormGroup;
    @ViewChild('swalModalDelete') swalModalDelete: any;

    registrationFormGroup: FormGroup;
    passwordFormGroup: FormGroup;
    constructor(private formBuilder: FormBuilder ,
                private fb: FormBuilder,
                private bsModalRef: BsModalRef,
                private authenticationService: AuthenticationService,
                private tosterMessageService : TosterMessageService,
                private modalService:BsModalService,
                public globals: Globals,) {
        this.frmSignup = this.createSignupForm();

        this.passwordFormGroup = this.formBuilder.group({
            password: [
                null,
                Validators.compose([
                    Validators.required,
                    // check whether the entered password has a number
                    CustomValidators.patternValidator(/\d/, {
                        hasNumber: true
                    }),
                    // check whether the entered password has upper case letter
                    CustomValidators.patternValidator(/[A-Z]/, {
                        hasCapitalCase: true
                    }),
                    // check whether the entered password has a lower case letter
                    CustomValidators.patternValidator(/[a-z]/, {
                        hasSmallCase: true
                    }),
                    // check whether the entered password has a special character
                    CustomValidators.patternValidator(
                        /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
                        {
                            hasSpecialCharacters: true
                        }
                    ),
                    Validators.minLength(8)
                ])
            ],
            repeatPassword: ['', Validators.required]
        }, {
            validator: CustomValidators.validate.bind(this)
        });
        this.registrationFormGroup = this.formBuilder.group({
            passwordFormGroup: this.passwordFormGroup
        });
    }

    ngOnInit() {
    }

    closeModal() {
        this.bsModalRef.hide();
    }



    createSignupForm(): FormGroup {
        return this.fb.group(
            {

                password: [
                    null,
                    Validators.compose([
                        Validators.required,
                        // check whether the entered password has a number
                        CustomValidators.patternValidator(/\d/, {
                            hasNumber: true
                        }),
                        // check whether the entered password has upper case letter
                        CustomValidators.patternValidator(/[A-Z]/, {
                            hasCapitalCase: true
                        }),
                        // check whether the entered password has a lower case letter
                        CustomValidators.patternValidator(/[a-z]/, {
                            hasSmallCase: true
                        }),
                        // check whether the entered password has a special character
                        CustomValidators.patternValidator(
                            /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
                            {
                                hasSpecialCharacters: true
                            }
                        ),
                        Validators.minLength(8)
                    ])
                ],
                confirmPassword: [null, Validators.compose([Validators.required])]
            },
            {
                // check whether our password and confirm password match
                validator: CustomValidators.passwordMatchValidator
            }
        );
    }


    submit() {
        this.swalModalDelete.show();
    }

    submitForm(){
        let that = this;
        this.authenticationService
            .passwordreset()
            .get(this.registrationFormGroup.value.passwordFormGroup)
            .subscribe(
                data => {
                    this.bsModalRef.hide();
                    this.tosterMessageService.showSuccess("Success", 'Password successfully changed');
                },
                error => {

                    this.tosterMessageService.showError("Error", 'Unable to change the password');
                });
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/app-reset-password/app-reset-password.component.ts